module.exports = __webpack_public_path__ + "img/greyhounds_online.db400bd0.png";